import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { CUSTOMER_STEPS, INTERNAL_STEPS, TRACKING_STEPS, STEPPER_STATUS_ALIAS, STATUS_LABELS } from './constants';

const CaseTicketStatusStepper = ({ status, type = 'customer', issueType }) => {
  const baseSteps = type === 'internal' ? INTERNAL_STEPS
    : issueType === 'tracking_follow' ? TRACKING_STEPS : CUSTOMER_STEPS;
  const effectiveStatus = STEPPER_STATUS_ALIAS[status] || status;
  // A detour status (รอข้อมูลเพิ่ม / รอลูกค้าตอบ) sits at the same POSITION as
  // รอหัวหน้าตอบ but must show its own label — the bar never lies about state.
  const steps = baseSteps.map((s) =>
    s.key === effectiveStatus && effectiveStatus !== status
      ? { ...s, label: STATUS_LABELS[status] || s.label }
      : s
  );
  const stepIndex = Math.max(0, steps.findIndex((s) => s.key === effectiveStatus));
  // Once closed, show every step (including "ปิดเคส" itself) as completed.
  const activeIndex = status === 'closed' ? steps.length : stepIndex;

  return (
    <Stepper activeStep={activeIndex} alternativeLabel>
      {steps.map((step) => (
        <Step key={step.key}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CaseTicketStatusStepper;
